import { render, staticRenderFns } from "./give-notice.vue?vue&type=template&id=b489692a"
import script from "./give-notice.vue?vue&type=script&lang=js"
export * from "./give-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b489692a')) {
      api.createRecord('b489692a', component.options)
    } else {
      api.reload('b489692a', component.options)
    }
    module.hot.accept("./give-notice.vue?vue&type=template&id=b489692a", function () {
      api.rerender('b489692a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/give-notice.vue"
export default component.exports